import { createSlice } from "@reduxjs/toolkit";
import { Role } from "./roles";

export interface UserOrgs {
  orgId: string;
  orgName: string;
  roles: Role[];
  totalRoles: number;
}

export interface UserOrgsState {
  Data: UserOrgs[];
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const UserOrgs = createSlice({
  name: "userOrgs",
  initialState: {
    Data: [],
    isLoading: false,
    isError: false
  },
  reducers: {
    getUserOrgs(state, _) {
      state.isLoading = true;
      state.isError = null;
    },
    getUserOrgsSuccess(state, action) {
      state.Data = action.payload;
      state.isLoading = false;
    },
    getUserOrgsError(state, action) {
      state.isLoading = false;
      state.isError = action.payload;
    }
  }
});

export const { getUserOrgs, getUserOrgsSuccess, getUserOrgsError } = UserOrgs.actions;
